module.exports = __webpack_public_path__ + "img/cutlery.b4b2867b.svg";